window.ustRuntimeReady = true;

const REVEAL_SELECTOR = '.ust-reveal, .ust-stagger';
const SAFETY_FLUSH_MS = 2500;

function revealAll() {
  for (const el of document.querySelectorAll(REVEAL_SELECTOR)) {
    el.classList.add('is-visible');
  }
}

function init() {
  const targets = document.querySelectorAll(REVEAL_SELECTOR);
  if (!targets.length) return;

  if (!('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  for (const el of targets) observer.observe(el);

  setTimeout(() => {
    for (const el of document.querySelectorAll(REVEAL_SELECTOR)) {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('is-visible');
      }
    }
  }, SAFETY_FLUSH_MS);
}

function returnFocusFromDrawer() {
  const drawer = document.getElementById('Details-menu-drawer-container');
  drawer?.addEventListener('toggle', () => {
    if (drawer.open) return;
    const lost = document.activeElement === document.body || drawer.contains(document.activeElement);
    if (lost) drawer.querySelector('summary')?.focus();
  });
}

function start() {
  init();
  returnFocusFromDrawer();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}
